<template>
  <div class="page-comp-cline-contacts">
    <div class="clue-linkman-vue3-tree-org">
      <vue3-tree-org :data="treeList" :horizontal="horizontal" :collapsable="collapsable" :node-draggable="false" :scalable="true" :only-one-node="onlyOneNode" :default-expand-level="1" :clone-node-drag="cloneNodeDrag" :tool-bar="false" :filter-node-method="filterNodeMethod">
        <!-- 自定义节点内容 -->
        <template v-slot="{ node }">
          <div class="tree-org-node__text node-label">
            <!-- <jw-space direction="vertical" fill> -->
            <div class="tree-org-node-item">
              <jw-space>
                <span v-if="node.id === null" :style="{ marginRight: '-8px' }">{{ $t('联系人') }}</span>
                <span v-else class="tree-org-node-item-name" :title="treeObj[node.id]?.name">{{ treeObj[node.id]?.name || '-' }}</span>
                <jw-tag size="small" v-if="treeObj[node.id]?.kdm === 0 || treeObj[node.id]?.kdm === 2" :color="treeObj[node.id]?.kdm === 0 ? 'pinkpurple' : 'orange'" bordered>{{ treeObj[node.id]?.kdm === 0 ? 'KDM' : treeObj[node.id]?.kdm === 2 ? '老板委托调研人' : treeObj[node.id]?.kdmName }}</jw-tag>
                <span v-show="treeObj[node.id]?.isDefault" :style="{ color: '#108ffe', fontSize: '15px' }">★</span>
              </jw-space>
              <jw-space>
                <jw-dropdown position="bl" @click="linkManDetail($event, node)" v-if="node.id !== null && userInfo?.orgId == huaYingOrdId">
                  <template v-if="type === 1 && userInfo?.roles?.indexOf('clue:addContacter') !== -1 && permission == 1">
                    <span class="tree-org-node-icon-search" alt="">
                      <img :src="iconSearch" />
                    </span>
                  </template>
                  <template v-else-if="type === 2 && userInfo?.roles?.indexOf('customer:addContacter') !== -1 && permission == 1">
                    <span class="tree-org-node-icon-search" alt="">
                      <img :src="iconSearch" />
                    </span>
                  </template>
                  <template v-else-if="type === 3 && userInfo?.roles?.indexOf('businessOpportunity:addContacter') !== -1 && permission == 1">
                    <span class="tree-org-node-icon-search" alt="">
                      <img :src="iconSearch" />
                    </span>
                  </template>
                  <template #content>
                    <div v-for="item in linkManDetailList" :key="item.key" class="detail-content">
                      <jw-space v-if="item.value" class="detail-item">
                        <span class="detail-label">{{ item.label }}</span>
                        <span class="detail-value">{{ item.value }}</span>
                      </jw-space>
                    </div>
                  </template>
                </jw-dropdown>
                <jw-dropdown position="bottom" @select="handleSelect($event, node)" v-if="node.id !== null">
                  <template v-if="type === 1 && ((buttons?.indexOf('clue:editContacter') !== -1 && userInfo?.roles?.indexOf('clue:editContacter') > -1) || (buttons?.indexOf('clue:delContacter') !== -1 && userInfo?.roles?.indexOf('clue:delContacter') > -1)) && permission == 1">
                    <jw-link class="tree-org-node-dot">···</jw-link>
                  </template>
                  <template v-else-if="type === 2 && ((buttons?.indexOf('customer:editContacter') !== -1 && userInfo?.roles?.indexOf('customer:editContacter') > -1) || (buttons?.indexOf('customer:delContacter') !== -1 && userInfo?.roles?.indexOf('customer:delContacter') > -1)) && permission == 1">
                    <jw-link class="tree-org-node-dot">···</jw-link>
                  </template>
                  <template v-else-if="type === 3 && ((buttons?.indexOf('businessOpportunity:editContacter') !== -1 && userInfo?.roles?.indexOf('businessOpportunity:editContacter') > -1) || (buttons?.indexOf('businessOpportunity:delContacter') !== -1 && userInfo?.roles?.indexOf('businessOpportunity:delContacter') > -1)) && permission == 1">
                    <jw-link class="tree-org-node-dot">···</jw-link>
                  </template>
                  <template #content>
                    <jw-doption :value="0"></jw-doption>
                    <jw-doption :value="1" v-if="userInfo?.orgId != orgId && ((buttons?.indexOf('clue:editContacter') !== -1 && userInfo?.roles?.indexOf('clue:editContacter') > -1) || (buttons?.indexOf('customer:editContacter') !== -1 && userInfo?.roles?.indexOf('customer:editContacter') > -1) || (buttons?.indexOf('businessOpportunity:editContacter') !== -1 && userInfo?.roles?.indexOf('businessOpportunity:editContacter') > -1))">{{ $t('编辑') }}</jw-doption>
                    <jw-doption :value="2" v-if="userInfo?.orgId != orgId && ((buttons?.indexOf('clue:delContacter') !== -1 && userInfo?.roles?.indexOf('clue:delContacter') > -1) || (buttons?.indexOf('customer:delContacter') !== -1 && userInfo?.roles?.indexOf('customer:delContacter') > -1) || (buttons?.indexOf('businessOpportunity:delContacter') !== -1 && userInfo?.roles?.indexOf('businessOpportunity:delContacter') > -1))">{{ $t('删除') }}</jw-doption>
                    <jw-doption v-if="!treeObj[node.id]?.isDefault" :value="3">{{ $t('设为默认联系人') }}</jw-doption>
                  </template>
                </jw-dropdown>
              </jw-space>
            </div>
            <div v-if="node.id !== null" class="tree-org-node-department">{{ treeObj[node.id]?.jobTitle || '-' }} | {{ treeObj[node.id]?.department || '-' }}</div>
            <div v-if="node.id !== null" class="tree-org-node-phone">
              <span>{{ treeObj[node.id]?.mobile || '-' }} </span>
              <template v-if="(permission == 1 && type === 1 && userInfo?.roles?.indexOf('clue:calling') !== -1 && buttons.indexOf('clue:calling') > -1) || (type === 2 && userInfo?.roles?.indexOf('customer:calling') !== -1 && buttons.indexOf('customer:calling') > -1) || (type === 3 && userInfo?.roles?.indexOf('businessOpportunity:calling') !== -1 && buttons.indexOf('businessOpportunity:calling') > -1)">
                <jw-link class="icon-phone" v-if="treeObj[node.id].mobile" :disabled="node.id === callId && outCallDisabled" @click.prevent="dialPhone(node)">
                  <!-- <icon-phone v-if="type === 1 && !customerId" :rotate="90" /> -->
                  <icon-phone v-if="type === 1 && userInfo?.roles?.indexOf('clue:calling') !== -1 && buttons.indexOf('clue:calling') > -1 && permission == 1" :rotate="90" />
                  <template v-if="type === 2 && userInfo?.roles?.indexOf('customer:calling') !== -1 && buttons.indexOf('customer:calling') > -1 && permission == 1">
                    <icon-phone :rotate="90" />
                  </template>
                  <template v-if="type === 3 && userInfo?.roles?.indexOf('businessOpportunity:calling') !== -1 && buttons.indexOf('businessOpportunity:calling') > -1 && permission == 1">
                    <icon-phone :rotate="90" />
                  </template>
                </jw-link>
              </template>
              <!-- <jw-link v-permission="[permission]" v-if="treeObj[node.id].mobile && userInfo.id === followUserId">
                <icon-phone :rotate="90"  />
              </jw-link> -->
            </div>
            <!-- <jw-link v-show="isShow === node.id" class="add-plus" :class="{ 'add-pluss': node.id === null }" @click="addPlus(0, node)"> -->
            <span class="add-plus" :class="{ 'add-pluss': node.id === null }" @click="addPlus(0, node)">
              <!-- <span title="添加联系人" class="add-plus-span" v-if="type === 1 && !customerId">✚</span> -->

              <template v-if="type === 1 && buttons.indexOf('clue:addContacter') > -1 && userInfo?.roles?.indexOf('clue:addContacter') !== -1">
                <span :title="$t('添加联系人')" class="add-plus-span" v-if="permission && permission == 1">✚</span>
              </template>
              <template v-else-if="type === 2 && buttons.indexOf('customer:addContacter') > -1 && userInfo?.roles?.indexOf('customer:addContacter') !== -1">
                <span :title="$t('添加联系人')" class="add-plus-span" v-if="permission && permission == 1">✚</span>
              </template>
              <template v-else-if="type === 3 && buttons.indexOf('businessOpportunity:addContacter') > -1 && userInfo?.roles?.indexOf('businessOpportunity:addContacter') !== -1">
                <span :title="$t('添加联系人')" class="add-plus-span" v-if="permission && permission == 1">✚</span>
              </template>
            </span>
            <!-- </jw-space> -->
          </div>
        </template>
      </vue3-tree-org>
    </div>
    <jw-modal v-model:visible="visible" :title="editAddTitle" @cancel="handleCancel" title-align="start" @ok="handleOk" width="450px" :mask-closable="false">
      <jw-form :model="form" label-align="left" ref="linkManRef" @submit="handleSubmit">
        <jw-form-item field="name" asterisk-position="end" :rules="{ required: true, message: $t('请填写联系人姓名') }" :validate-trigger="['change', 'input', 'blur']" class="form-label-text" :label-col-style="{ width: '110px' }">
          <template #label>
            <xl-label-text :value="$t('联系人')" :row="1" />
          </template>
          <jw-input v-model="form.name" :placeholder="$t('请填写联系人姓名')" :style="{ width: '265px' }" />
        </jw-form-item>
        <jw-form-item field="mobile" asterisk-position="end" :rules="[{ required: userInfo?.orgId == huaYingOrdId && (type == 2 || type == 3) ? false : false, message: $t('tips.phoneNumber') }]" :validate-trigger="['input', 'blur']" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('联系电话')" :row="1" />
          </template>
          <jw-input style="margin: 0 10px 0 0" :max-length="100" v-model="form.mobile" :placeholder="$t('tips.phoneNumber')" :style="{ width: '265px' }" />
        </jw-form-item>
        <!-- 以下两个字段是华英资本并且客户和商机才有的字段 -->
        <template v-if="userInfo?.orgId == huaYingOrdId && (type == 2 || type == 3)">
          <jw-form-item field="city" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="{ required: false, message: $t('请选择所在城市') }" :validate-trigger="['change', 'input', 'blur']">
            <template #label>
              <xl-label-text :value="$t('所在城市')" :row="1" />
            </template>
            <jw-cascader :placeholder="$t('请选择所在城市')" class="system-form-item-value" v-model="form.city" :options="cityList" allow-clear allow-search :style="{ width: '265px' }"> </jw-cascader>
          </jw-form-item>
          <jw-form-item field="important" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text" :rules="{ required: false, message: $t('请选择个人重要性') }" :validate-trigger="['change', 'input', 'blur']">
            <template #label>
              <xl-label-text :value="$t('个人重要性')" :row="1" />
            </template>
            <jw-select :placeholder="$t('请选择个人重要性')" class="system-form-item-value" v-model="form.important" :options="personImportantList" allow-clear allow-search :style="{ width: '265px' }"> </jw-select>
          </jw-form-item>
        </template>
        <jw-form-item field="jobTitle" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('联系人职位')" :row="1" />
          </template>
          <jw-select :placeholder="$t('请选择联系人职位')" class="system-form-item-value" v-model="form.jobTitle" :options="userInfo?.orgId != huaYingOrdId ? positionList : huaYingOrdPositionList" allow-clear allow-search :style="{ width: '265px' }"> </jw-select>
        </jw-form-item>
        <jw-form-item field="department" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="userInfo?.orgId == qijieOrgId ? '产品采购态度' : $t('联系人所在部门')" :row="1" />
          </template>
          <jw-input v-model="form.department" :placeholder="userInfo?.orgId == qijieOrgId ? '请填写产品采购态度' : $t('请填写联系人所在部门')" />
        </jw-form-item>
        <jw-form-item field="kdm" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
          <template #label>
            <xl-label-text :value="$t('是否KDM')" :row="1" />
          </template>
          <jw-select :placeholder="$t('请选择是否KDM')" class="system-form-item-value" v-model="form.kdm" :options="isKDMList" allow-clear allow-search :style="{ width: '265px' }"> </jw-select>
        </jw-form-item>
        <!-- 以下三个字段是华英资本并且客户和商机才有的字段 -->
        <template v-if="userInfo?.orgId == huaYingOrdId && (type == 2 || type == 3)">
          <jw-form-item field="wechat" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('微信号')" :row="1" />
            </template>
            <jw-input v-model="form.wechat" :placeholder="$t('请填写微信号')" :style="{ width: '265px' }" />
          </jw-form-item>
          <jw-form-item field="email" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('邮箱')" :row="1" />
            </template>
            <jw-input v-model="form.email" :placeholder="$t('请填写邮箱')" :style="{ width: '265px' }" />
          </jw-form-item>
          <jw-form-item field="address" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('详细地址')" :row="1" />
            </template>
            <jw-input v-model="form.address" :placeholder="$t('请填写详细地址')" :style="{ width: '265px' }" />
          </jw-form-item>
          <jw-form-item field="blurb" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('个人简介')" :row="1" />
            </template>
            <jw-textarea
              :placeholder="$t('请填写个人简介')"
              v-model="form.blurb"
              :auto-size="{
                minRows: 2,
                maxRows: 5
              }"
              :style="{ width: '265px' }"
            />
          </jw-form-item>
        </template>
        <template v-else>
          <jw-form-item field="blurb" asterisk-position="end" :label-col-style="{ width: '110px' }" class="form-label-text">
            <template #label>
              <xl-label-text :value="$t('备注')" :row="1" />
            </template>
            <jw-textarea
              :placeholder="$t('请填写备注')"
              v-model="form.blurb"
              :auto-size="{
                minRows: 2,
                maxRows: 5
              }"
              :style="{ width: '265px' }"
            />
          </jw-form-item>
        </template>
      </jw-form>
    </jw-modal>
    <!-- 天科云外呼 S -->
    <xl-out-call-tky ref="tkyRef" />
    <!-- 天科云外呼 E -->
    <!-- 传显科技 - 外呼 S -->
    <xl-out-call-cxkj ref="cxkjRef" />
    <!-- 传显科技 - 外呼 E -->
  </div>
</template>

<script>
import { reactive, toRefs, ref, inject, onMounted } from 'vue';
import { Modal } from '@arco-design/web-vue';
import { tools } from '@/utils/tools';
import { publicService, layoutService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useUserStore, useContactsStore, useOutCallStore } from '@/store';
import { positionList, isKDMList, isKDMObj, lingChuOrgId, huaYingOrdId, huaYingOrdPositionList, personImportantList, personImportantObj, qijieOrgId } from '@/utils/const';
import iconSearch from '@/assets/images/icon-search.svg';
import { useI18n } from 'vue-i18n';

export default {
  name: 'XlContacts',
  props: {
    moduleId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const { t } = useI18n();
    const linkManRef = ref();
    const { userInfo } = useUserStore();
    const { callConfig } = useOutCallStore();
    console.log(userInfo);
    // 领储7  天客云tkyRef
    const tkyRef = ref();
    // 条道12  传显科技cxkjRef
    const cxkjRef = ref();
    const data = reactive({
      isShow: -1,
      visible: false,
      editAddTitle: '',
      outCallDisabled: false,
      callId: null,
      id: inject('detailParams').id, //客户id
      nodeId: '', //树节点id
      pid: '', //联系人上级id
      type: inject('detailParams')?.entity, //1-线索 2-客户 3-商机 4-产品\
      permission: inject('detailParams')?.permission, //权限
      followUserId: inject('defaultParams')?.followUserId, //跟进人id
      customerId: inject('detailParams')?.customerId, //是否展示编辑
      nodeType: '',
      cityList: [],
      linkManDetailList: [
        { id: 1, label: t('联系人'), key: 'name', value: '' },
        { id: 2, label: t('联系电话'), key: 'mobile', value: '' },
        { id: 3, label: t('所在城市'), key: 'city', value: '' },
        { id: 4, label: t('个人重要性'), key: 'important', value: '' },
        { id: 5, label: t('联系人职位'), key: 'jobTitle', value: '' },
        { id: 6, label: t('联系人所在部门'), key: 'department', value: '' },
        { id: 7, label: t('是否KDM'), key: 'kdm', value: '' },
        { id: 8, label: t('微信号'), key: 'wechat', value: '' },
        { id: 9, label: t('邮箱'), key: 'email', value: '' },
        { id: 10, label: t('详细地址'), key: 'address', value: '' },
        { id: 11, label: t('个人简介'), key: 'blurb', value: '' }
      ],
      form: {
        isDefault: false,
        name: '', //联系人
        jobTitle: '', //联系人职位
        department: '', //联系人所在部门
        mobile: '', //联系电话
        kdm: '', //是否KDM
        city: '', //城市
        important: '', //重要性
        wechat: '', //微信
        email: '', //邮箱
        address: '', //详细地址
        blurb: '' //简介 || 备注
      },
      treeObj: {},
      treeList: {
        id: null,
        style: { width: '100px', height: '40px', cursor: 'pointer', display: 'flex', 'align-items': 'center', 'justify-content': 'center' },
        children: []
      },
      horizontal: true, //是否横向
      collapsable: false, //是否可以展开节点
      onlyOneNode: false,
      cloneNodeDrag: true
    });
    // 新增和编辑确认按钮
    const handleOk = () => {
      linkManRef.value.handleSubmit();
    };
    // 取消弹窗
    const handleCancel = () => {
      data.visible = false;
      linkManRef.value.clearValidate();
    };
    // 表单提交验证
    const handleSubmit = ({ values, errors }) => {
      console.log('表单提交验证', values, errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        linkManRef.value.setFields(errorArray);
        data.visible = true;
        return;
      } else {
        if (data.nodeType === 0) {
          getContactAdd();
        } else if (data.nodeType === 1) {
          getContactUpdate();
        }
      }
    };
    // 获取联系人列表树  S
    const getContactsTree = () => {
      const params = {
        businessId: data.id,
        type: data.type, //1-线索 2-客户 3-商机 4-产品
        calling: false
      };
      useGetContacts.getContactList(params).then((res) => {
        const getTree = tools.arrayToTree(res?.result, null);
        data.treeObj = getTree.obj;
        data.treeList.children = getTree.tree;
        console.log(res.result);
      });
    };
    // 添加子节点
    const addPlus = (id, node) => {
      handleSelect(id, node);
    };
    // 新增联系人
    const getContactAdd = () => {
      const params = {
        pid: data.nodeId,
        businessId: data.id,
        type: data.type,
        ...data.form
      };
      useGetContacts.addContacts(params, getContactsTree);
    };
    // 编辑联系人
    const getContactUpdate = () => {
      console.log(data.form);
      data.form.kdm = data.form.kdm === '' ? undefined : data.form.kdm;
      const params = {
        id: data.nodeId,
        type: data.type, //1-线索 2-客户 3-商机 4-产品
        pid: data.pid,
        businessId: data.id,
        ...data.form
      };
      useGetContacts.updateContacts(params, getContactsTree);
    };
    // 设置为默认
    const getContactDefault = () => {
      const params = {
        id: data.nodeId,
        type: data.type //1-线索 2-客户 3-商机 4-产品
      };
      useGetContacts.setContactDefault(params, getContactsTree);
    };
    // 删除联系人
    const deleteContact = () => {
      const params = {
        id: data.nodeId,
        type: data.type //1-线索 2-客户 3-商机 4-产品
      };
      useGetContacts.removeContact(params, getContactsTree);
    };
    // 点击下拉菜单
    const handleSelect = (v, node) => {
      console.log('点击下拉菜单', v, node);
      if (userInfo?.orgId == huaYingOrdId) {
        getSelections();
      }
      data.nodeType = v;
      data.pid = node.pid;
      data.nodeId = node.id;
      data.form.isDefault = node.$$data.isDefault;
      if (v === 0) {
        console.log('新增联系人');
        linkManRef.value.resetFields();
        data.editAddTitle = t('新增联系人');
        data.form.kdm = null;
        data.visible = true;
      } else if (v === 1) {
        console.log('编辑联系人');
        if (node) {
          const { name, jobTitle, department, mobile, kdm, isDefault, city, important, wechat, email, address, blurb } = data.treeObj[node.id];
          console.log(kdm);
          data.form.name = name;
          data.form.jobTitle = jobTitle;
          data.form.department = department;
          data.form.mobile = mobile;
          data.form.kdm = kdm;
          data.form.isDefault = isDefault;
          data.form.city = city;
          data.form.important = important;
          data.form.wechat = wechat;
          data.form.email = email;
          data.form.address = address;
          data.form.blurb = blurb;
        }
        data.editAddTitle = t('编辑联系人');
        data.visible = true;
      } else if (v === 2) {
        console.log('删除节点');
        Modal.confirm({
          titleAlign: 'start',
          width: 400,
          simple: false,
          title: t('确认删除此节点？'),
          content: t('tips.deleteContact'),
          onOk: () => {
            console.log(v); //改为删除接口
            deleteContact();
          }
        });
      } else {
        console.log('设为默认联系人');
        getContactDefault();
      }
    };
    // 点击放大镜
    const linkManDetail = (event, node) => {
      console.log(351, event, node);
      data.linkManDetailList?.forEach((item) => {
        const key = item.key;
        const nodeKey = node?.$$data;
        if (key === 'name') {
          item.value = nodeKey?.name;
        } else if (key === 'mobile') {
          item.value = nodeKey?.mobile;
        } else if (key === 'city') {
          item.value = nodeKey?.city;
        } else if (key === 'important') {
          item.value = personImportantObj?.[nodeKey?.important];
        } else if (key === 'jobTitle') {
          item.value = nodeKey?.jobTitle;
        } else if (key === 'department') {
          item.value = nodeKey?.department;
        } else if (key === 'kdm') {
          item.value = isKDMObj?.[nodeKey?.kdm];
        } else if (key === 'wechat') {
          item.value = nodeKey?.wechat;
        } else if (key === 'email') {
          item.value = nodeKey?.email;
        } else if (key === 'address') {
          item.value = nodeKey?.address;
        } else if (key === 'blurb') {
          item.value = nodeKey?.blurb;
        }
      });
    };
    // 拨打电话
    const dialPhone = (node) => {
      console.log(256, node);
      data.callId = node.id;
      data.outCallDisabled = true;
      const params = {
        id: node?.$$data?.businessId,
        linkManId: node?.$$data?.id,
        type: data?.type,
        callee: node?.$$data?.mobile,
        calleeName: node?.$$data?.name
      };
      // 如果orgid 是7 是领储 则展示天科云
      console.log(5357, lingChuOrgId);
      if (callConfig.default?.platformCode === 'kty') {
        // 天科云
        tkyRef.value?.open({ id: params.id, type: params?.type, linkManId: params.linkManId });
        data.outCallDisabled = false;
        return;
      }
      if (callConfig.default?.platformCode === 'cx') {
        // 传显科技
        cxkjRef.value?.open({ id: params.id, type: params?.type, linkManId: params.linkManId });
        data.outCallDisabled = false;
        return;
      }
      useGetContacts.callOut(params).then(() => {
        data.outCallDisabled = false;
      });
    };
    //
    const getSelections = async () => {
      try {
        const json = await publicService.getSelections({ fieldKey: 'city' });
        if (!json.error) {
          console.log(423, json.result);
          data.cityList = json.result;
        } else {
          Message.error(json.error?.msg || t('数据获取失败'));
        }
        // console.log('角色删除', roleDelete);
      } catch (e) {
        console.log(e);
        Message.error(e.message || e.statusText || t('数据获取失败'));
      }
    };
    // 过滤节点
    const filterNodeMethod = (value, data) => {
      console.log('过滤节点filterNodeMethod', value, data);
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    const useGetContacts = useContactsStore(); //拨打电话-获取联系人
    onMounted(() => {
      getContactsTree();
      getDetail();
    });
    const buttons = ref([]);
    const getDetail = async () => {
      if (!props?.moduleId) {
        return false;
      }
      try {
        const params = {
          entity: data.type,
          moduleId: props.moduleId,
          businessId: data.id,
          apiIndex: props.moduleId
        };
        const json = await layoutService.getDetail(params);
        if (!json.error) {
          const _buttons = [];
          json?.result?.map((b) => {
            _buttons.push(b.value);
          });
          buttons.value = _buttons;
        }
      } catch (e) {
        console.log(e);
      }
    };
    return {
      filterNodeMethod,
      getContactsTree,
      getContactAdd,
      tkyRef,
      cxkjRef,
      getContactUpdate,
      deleteContact,
      handleSelect,
      userInfo,
      addPlus,
      handleSubmit,
      linkManRef,
      handleOk,
      handleCancel,
      positionList,
      huaYingOrdId,
      huaYingOrdPositionList,
      isKDMList,
      dialPhone,
      qijieOrgId,
      linkManDetail,
      personImportantList,
      iconSearch,
      buttons,
      ...toRefs(data)
    };
  }
};
</script>

<style scoped lang="less">
@import './xl-contacts.less';
</style>
